var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileSnsKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "#FFE000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.753 23.4672C32.753 19.8962 29.226 17.0012 24.877 17.0012C20.528 17.0012 16.999 19.9012 16.999 23.4672C16.999 26.5672 19.6611 29.1532 23.2091 29.7822L22.653 33.7432L25.983 29.8432C29.796 29.3982 32.753 26.7282 32.753 23.4672Z",
    fill: "#3C1E20",
    stroke: "#3C1E20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSnsKakao);
export default __webpack_public_path__ + "static/media/mobile-sns-kakao.7df2409bfbc521d5993dcfce67a2ce37.svg";
export { ForwardRef as ReactComponent };